import { Component, Input, ElementRef, Output, EventEmitter } from '@angular/core';

@Component({
    selector: 'dropdown',
    templateUrl: './dropdown.component.html',
    styleUrls: ['./dropdown.component.css'],
    host: {
        "(window:resize)": "onResize($event)"
    }
})

export class DropdownComponent {
    @Input() items: Array<any>;
    @Input() label: string;
    @Input() icon: string;
    @Input() selectedItem: any = null;

    // Whether to activate or not the adaptative height computation for the dropdown items list
    @Input() adaptativeHeight: boolean = false;
    // Maximal height of the dropdown items in pixels
    @Input() fullHeightInPx: number = 500;
    // Intermediate height for the dropdown items in pixels.
    @Input() intermediateHeightInPx: number = 300;

    @Output() onSelectCallback: EventEmitter<any> = new EventEmitter();

    // Whether the dropdown items have to be displayed above or below the select box
    displayAbove:boolean;
    // Max height for the dropdown items
    maxHeight: string;

    constructor(private elementRef: ElementRef) {
    }

    ngOnChanges(changes: any) {
        if (changes.selectedItem && changes.selectedItem.currentValue) {
            this.label = changes.selectedItem.currentValue.label;
            if (changes.selectedItem.currentValue.icon) {
                this.icon = changes.selectedItem.currentValue.icon;
            }
        }
    }

    onItemSelectEmit(event) {
        this.selectedItem = event;
        this.label = event.label;
        if (event.icon) {
            this.icon = event.icon;
        }

        this.onSelectCallback.emit(event);
    }

    /**
     * Handle focus events in the dropdown
     * @param event
     */
    onFocus(event){
        this.resizeDropDownItems();
    }

    /**
     * Handle resize of the window
     * @param event
     */
    onResize(event){
        this.resizeDropDownItems();
    }

    /**
     * Compute the position of the dropdown items : above or below ? Full height or downsized ?
     */
    resizeDropDownItems(){
        if(this.adaptativeHeight){
            var boundingBox = this.elementRef.nativeElement.getBoundingClientRect();
            var margin=10;
            // The dropdown height + the margin below
            var dropDownHeight = boundingBox.height+5;
            var spaceAvailableBelow = window.innerHeight-boundingBox.top-dropDownHeight-margin;
            var spaceAvailableAbove = boundingBox.top-margin;
            if(spaceAvailableBelow<this.fullHeightInPx){
                if(spaceAvailableBelow<this.intermediateHeightInPx && spaceAvailableBelow<spaceAvailableAbove){
                    // Display the dropdown above the select box
                    this.displayAbove=true;
                    this.maxHeight = spaceAvailableAbove+'px';
                }
                else{
                    // Display the dropdown below the select box with reduced height
                    this.displayAbove=false;
                    this.maxHeight = spaceAvailableBelow+'px';
                }
            }
            else{
                // Display the dropdown below the select box with full height
                this.displayAbove=false;
                this.maxHeight = this.fullHeightInPx+'px';
            }
        }
    }
}



// WEBPACK FOOTER //
// /home/gitlab-runner/builds/VyQQATNu/0/groupe-dev/nm17/node_modules/nm-socle-application/app/components/ng-dropdown/dropdown.component.ts